import { debounce } from './helpers'

export default () => {
  let w
  const setHeight = () => {
    if (window.innerWidth === w) return
    w = window.innerWidth
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    )
  }
  const debounced = debounce(setHeight, 300)
  window.addEventListener('resize', debounced)
  window.addEventListener('orientationchange', debounced)
  setHeight()
}
